"use strict";

import $ from "jquery";

class ImageFallback
{
    constructor(master, fallback) {
        if (master.length < 1 || fallback.length < 1) {
            return;
        }

        if (typeof window.CSS !== "undefined") {
            if (! CSS.supports("object-fit", "cover")) {
                $(master).hide();
                $(fallback).show();
            }
        }
        else {
            $(master).hide();
            $(fallback).show();
        }
    }
}

export default ImageFallback;
